import { ArrowDown, ArrowUp, Minus } from "lucide-react";
import type { KpiMetric } from "../../types/status";

interface KpiCardProps {
  label: string;
  value: number | null;
  unit: string;
  metric: KpiMetric;
  higherIsBetter: boolean;
  onClick: () => void;
}

export default function KpiCard({ label, value, unit, metric, higherIsBetter, onClick }: KpiCardProps) {
  const { change_pct } = metric;

  let trendEl: React.ReactNode = null;
  if (change_pct !== null && change_pct !== undefined && change_pct !== 0) {
    const isUp = change_pct > 0;
    const isGood = higherIsBetter ? isUp : !isUp;
    const colour = isGood ? "text-green-600" : "text-red-500";
    const Icon = isUp ? ArrowUp : ArrowDown;
    trendEl = (
      <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${colour}`}>
        <Icon size={11} />
        {Math.abs(change_pct).toFixed(1)}%
      </span>
    );
  } else if (change_pct === 0) {
    trendEl = (
      <span className="inline-flex items-center gap-0.5 text-xs font-medium text-gray-400">
        <Minus size={11} />
        0%
      </span>
    );
  }

  const displayValue = value !== null && value !== undefined
    ? (unit === "%" ? value.toFixed(2) : value.toFixed(1))
    : "—";

  return (
    <button
      onClick={onClick}
      className="group flex flex-col gap-2 rounded-xl border border-gray-200 bg-white px-5 py-4 text-left transition-all hover:border-blue-300 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
    >
      <span className="text-xs font-semibold uppercase tracking-wider text-gray-400">{label}</span>
      <div className="flex items-end justify-between gap-2">
        <span className="text-2xl font-bold text-gray-900 tabular-nums">
          {displayValue}
          {value !== null && <span className="ml-0.5 text-base font-medium text-gray-500">{unit}</span>}
        </span>
        {trendEl ?? <span className="text-xs text-gray-300">vs prior period</span>}
      </div>
      <span className="text-xs text-gray-400 group-hover:text-blue-500">View incidents →</span>
    </button>
  );
}
